import React, { useEffect, useMemo, useState } from 'react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const JobDescription = ({ jobDescription }) => {
  const isTrimmed = jobDescription?.length > 250;
  const trimmedDescription = useMemo(() => {
    if (!jobDescription || !isTrimmed) return jobDescription;

    return `${jobDescription.substring(0, 249)}...`;
  }, [isTrimmed, jobDescription]);

  const [description, setDescription] = useState(trimmedDescription);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setDescription(trimmedDescription);
    setIsExpanded(false);
  }, [jobDescription, trimmedDescription]);

  const handleExpandClick = () => {
    if (!isTrimmed) return null;
    setDescription(isExpanded ? trimmedDescription : jobDescription);
    setIsExpanded(!isExpanded);
  };

  return (
    <Box cursor={isTrimmed ? 'pointer' : ''} onClick={() => handleExpandClick()}>
      <Text mb={2} textStyle="bodyMd" whiteSpace="pre-line">{description ?? '-'}</Text>
      {description?.length > 250 && (
        <Flex alignItems="center" flexFlow="row nowrap">
          <Text color="primaryScale.600" mr={2} textStyle="bodySm500">{isExpanded ? 'Show Less' : 'Show More'}</Text>
          <Icon as={isExpanded ? BsChevronUp : BsChevronDown} color="primaryScale.600" />
        </Flex>
      )}
    </Box>
  );
};

JobDescription.propTypes = { jobDescription: PropTypes.string };

export default JobDescription;
